import React, { useState } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import { AUTH_MODAL_EVENT } from 'Pods/LazyLoaded/AiSignInModal/constants'
import { MODE } from 'Pods/LazyLoaded/AuthModal/constants'
import LazyAuthModal from 'Pods/LazyLoaded/AuthModal/LazyAuthModal'
import i18n from 'Pods/Shared/I18n'

function isAiStudioPage() {
  if (typeof window === 'undefined') return false
  return /^\/ai(\/|$)/.test(window.location.pathname)
}

function GuestActions({ locale = 'en' }) {
  const [authModalMode, setAuthModalMode] = useState(null)

  const openAuthModal = (mode) => {
    // On /ai the auth flow is the dedicated AI sign-in modal (owned by ThreeDStudio /
    // AiSubLanding), not the marketplace AuthModal. Hand the click off via the
    // global event bus, mirroring LegacyNavigation's UserMenu.
    if (isAiStudioPage()) {
      /* eslint-disable-next-line no-undef */
      App.events.publish(AUTH_MODAL_EVENT, { mode })
      return
    }

    setAuthModalMode(mode)
  }

  const handleLoginClick = () => openAuthModal(MODE.LOGIN)
  const handleSignupClick = () => openAuthModal(MODE.SIGNUP)
  const handleAuthModalClose = () => setAuthModalMode(null)

  return (
    <div className="unified-nav__user">
      <Button type="secondary" size="small" onClick={handleLoginClick}>
        {i18n.t('navigation.user.login', { ns: 'rails', lng: locale })}
      </Button>
      <Button size="small" onClick={handleSignupClick}>
        {i18n.t('navigation.user.register', { ns: 'rails', lng: locale })}
      </Button>

      {authModalMode && (
        <LazyAuthModal mode={authModalMode} onClose={handleAuthModalClose} />
      )}
    </div>
  )
}

GuestActions.propTypes = {
  locale: string,
}

export default GuestActions
